import { DoctorPreview } from '../../../api/doctor.types'
import { DoctorsAllAction } from './doctors.all.types'

export const doctorsAllRequestAction = (): DoctorsAllAction => ({ type: 'DOCTORS_ALL_REQUEST' })
export const doctorsAllSuccessAction = (doctors: DoctorPreview[]): DoctorsAllAction => ({ type: 'DOCTORS_ALL_SUCCESS', params: doctors })
export const doctorsAllFailureAction = (error?: any): DoctorsAllAction => ({ type: 'DOCTORS_ALL_FAILURE', params: error })